import { FC } from 'react';
import Image from 'next/legacy/image';
import Link from 'next/link';

/**
 * The top header for the step funnels: matches the website nav styling (dark
 * surface + hub logo) but carries no menu items, search or auth controls —
 * the funnel chrome below it owns navigation.
 */
const FunnelHeader: FC = () => (
  <header className="bg-neutral-800 shadow-300">
    <div className="mx-auto max-w-screen-3xl px-4 py-3">
      <Link href="/" className="flex h-[50px] w-[50px]">
        <Image
          src="/images/hub-logo.svg"
          alt="Fantasy Football Hub"
          height={50}
          width={50}
        />
      </Link>
    </div>
  </header>
);

export default FunnelHeader;
